<c-smart-table
  #smartTable="cSmartTable"
  activePage="1"
  cleaner
  clickableRows
  [columnFilter]="false"
  [columnSorter]="true"
  [columns]="columns"
  footer = "false"
  header
  [itemsPerPageSelect]="false"
  [itemsPerPage]="10"
  [items]="tableData"
  pagination
  selectable = "false"
  [sorterValue]="{ column: 'name', state: 'asc' }"
  [tableBodyProps]="{align: 'middle'}"
  [tableFilter]="true"
  tableFilterLabel = ""
  tableFilterPlaceholder = "Search..."
  [tableFootProps]="{color: 'primary'}"
  [tableHeadProps]="{color: 'primary'}"
  [tableProps]="{ hover: true, striped: true, responsive: true }"
  noItemsLabel
>
  <!-- <ng-template cTemplateId="tableCustomHeader">
    <div [cCol]="'auto'" class="p-0 ms-auto">
      <button cButton color="success" (click)="smartTable.footer = !smartTable.footer">
        Footer is {{smartTable.footer ? 'ON' : 'OFF'}}
      </button>
    </div>
  </ng-template> -->

  <!-- <ng-template cTemplateId="tableDetails" let-item="item">
    <div [visible]="this.details_visible[item._id]===true" cCollapse>
      <c-card class="rounded-0">
        <c-card-body>
          <h5>{{item['name']}}</h5>
          <p class="text-muted">User since: {{item['registered']}}</p>
        </c-card-body>
        <c-card-footer>
          <button cButton color="info" size="sm">
            User Settings
          </button>
          <button cButton class="ms-1" color="danger" size="sm">
            Delete
          </button>
        </c-card-footer>
      </c-card>
    </div>
  </ng-template> -->
  <!-- <ng-template cTemplateId="tableData" let-columnName="columnName" let-item="item" let-tdContent="tdContent">
    <td [cTableActive]="smartTable.tableDataCellProps(item, columnName)?.['active']"
        [cTableColor]="smartTable.tableDataCellProps(item, columnName)?.color"
        [cAlign]="smartTable.tableDataCellProps(item, columnName)?.align"
        [ngClass]="smartTable.tableDataCellClasses(item, columnName)"
    >
      <ng-container [ngSwitch]="columnName">
        <ng-container *ngSwitchCase="'status'">
          <c-badge [color]="getBadge(tdContent)">
            {{(item[columnName])}}
          </c-badge>
        </ng-container>
        <ng-container *ngSwitchCase="'show'" class="py-2">
          <button (click)="toggleDetails(item['id'])" cButton color="primary" size="sm" variant="outline">
            Show
          </button>
        </ng-container>
        <ng-container *ngSwitchDefault>
          {{tdContent}}
        </ng-container>
      </ng-container>
    </td>
  </ng-template> -->
</c-smart-table>
